import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { ArtikelAsset } from './artikelasset.entity';
//#endregion

export const ArtikelAssetConfig = {
  name: "ArtikelAsset",
  annotations: [],
  fields: {
    artikelId: {type: 'Edm.Int32'},
    assetId: {type: 'Edm.Int32'},
    sortValue: {type: 'Edm.Int32'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    artikel: {type: 'entities.Artikel', navigation: true, field: 'artikelId', ref: 'id'},
    asset: {type: 'entities.assets.Asset', navigation: true, field: 'assetId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<ArtikelAsset>;